
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const coolingFailureChallenge: Challenge = {
  id: 'cooling-failure',
  title: 'Cooling System Failure',
  description: 'The cooling system at your facility has partially failed during a heat wave.',
  options: [
    {
      text: 'Shut down affected miners until repairs are completed',
      outcome: 'You protected your equipment but lost mining time.',
      kpiEffects: {
        uptime: -3,
        profitMargin: -2
      },
      experienceGain: 10
    },
    {
      text: 'Implement emergency cooling measures and continue operations',
      outcome: 'Your quick fix worked but at higher energy costs.',
      kpiEffects: {
        energyCost: 0.02,
        efficiency: -1
      },
      experienceGain: 15
    },
    {
      text: 'Upgrade to a more resilient cooling system',
      outcome: 'The investment paid off with a more reliable and efficient cooling solution.',
      kpiEffects: {
        uptime: 2,
        energyCost: -0.01,
        profitMargin: -4
      },
      experienceGain: 25,
      skillUnlock: skills.find(s => s.id === 'cooling-optimization')!
    }
  ],
  difficulty: 3
};
